import { Form } from 'formik';
import styled from 'styled-components';

const FormikForm = styled(Form)`
  margin: 0rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export default FormikForm;


// WEBPACK FOOTER //
// ./src/components/Form/FormikForm.js